<template>
  <div class="justify-content-center align-items-center flex">
    <div>
      <div class="text-center">
        <div class="h3">Checking Invite Code</div>
        {{ company.name }} <br>
        {{ managed_id }} <br>

        <v-progress-circular
          v-if="custodianLoading.join"
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>

        <v-alert v-if="errorMessage" type="warning">
          {{ errorMessage }}
        </v-alert>
      </div>
    </div>

    <v-dialog
      v-model="successDialog"
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Success. Please wait.
          <v-progress-linear
            class="mb-0"
            color="white"
            indeterminate
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts" setup>
import {computed, onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {useStore} from 'vuex';

const route = useRoute();
const router = useRouter();
const store = useStore();

const managed_id = ref(route.params.managed_id as string);
const errorMessage = ref<string | null>(null);
const successDialog = ref(false);

const company = computed(() => store.getters['company/company']);
const custodianLoading = computed(() => store.getters['custodian/loading']);

const fetchCustodian = async (id: string) => {
  const result = await store.dispatch('custodian/join', id);

  if (result?.joined) {
    successRedirectDialogInit();
  } else if (result?.error) {
    errorMessage.value = result.error;
  }
};

const successRedirectDialogInit = () => {
  successDialog.value = true;

  // Set a timeout for 3 seconds and redirect to the listings page
  setTimeout(() => {
    router.push({name: 'listing.index'}).catch(() => {
    });
  }, 2000);
};

onMounted(() => {
  if (route.params.managed_id) {
    void fetchCustodian(route.params.managed_id as string);
  }
});
</script>
